(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabin-v2-size"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cabin-size-filter')) {
 customElements.define('cabin-size-filter', class extends HTMLElement {
  connectedCallback() {
   if (this.bound) return;
   this.bound = true;
   this.addEventListener('click', (event) => {
    const button = event.target.closest('button[data-size]');
    if (!button) return;
    this.querySelectorAll('button[data-size]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    let count = 0;
    this.querySelectorAll('[data-capacity]').forEach(card => {
     card.hidden = button.dataset.size !== 'all' && card.dataset.capacity !== button.dataset.size;
     if (!card.hidden) count++;
    });
    const status = this.querySelector('[data-filter-status]');
    status.textContent = status.dataset.countLabel.replace('[count]', count);
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
